// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"list_listContainer__MN_fA","title":"list_title__2Yk7K"};